// Copyright (c) 2026 AesirX.io Ltd. All rights reserved.
// This source code is proprietary and confidential.
// See LICENSE.md for licensing terms.
// ── PDPL Rights Type Enrichment ───────────────────────────────
export const PDPL_RIGHT_TYPES = [
    'access',
    'correction',
    'deletion',
    'consent_withdrawal',
    'restriction',
    'portability',
    'objection',
    'protective_measures',
    // Sprint 63.31.0 (#438) — Law 91 Điều 4 khoản 1 điểm a, b (first half), đ.
    // The union stays the platform's request vocabulary (unified with
    // `RequestType`); whether a right exists for an organisation is the installed
    // frameworks' `data_subject_request_types` (owner ruling OD-B).
    'processing_information',
    'consent_decision',
    'complaint_or_compensation',
];
/**
 * fix-sprint-20261004-63-8-2 F4 — a response template's right type: one right, or `*` for a template
 * that answers any right (the templates page offers it). The create route reads
 * this list.
 */
export const RESPONSE_TEMPLATE_RIGHT_TYPES = ['*', ...PDPL_RIGHT_TYPES];
//# sourceMappingURL=dsr-fulfillment.js.map